import moment from 'moment';
import useSetExport from '@components/export/useSetExport';

function useResiliencyTableExport({ data, columns, interval }) {
  const headers = columns.map(({ title, dataKey }) => {
    return { title, key: dataKey, type: null };
  });

  const intervalStr = `(${moment(interval.from).format()} - ${moment(interval.to).format()})`;

  useSetExport({
    pageKey: 'precision',
    sectionKey: 'resiliency',
    widgetKey: 'avoidance-specifics',
    widgetInfo: {
      title: `Avoidance Specifics ${intervalStr} Export`,
    },
    data,
    headers,
  });
}

export default useResiliencyTableExport;
